import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Desert',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("circle", {
        attrs: { cx: "6.5", cy: "6.5", r: "3.5" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "3", y1: "29", x2: "29", y2: "29" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "16.5", y1: "5.5", x2: "16.5", y2: "28.5" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M21.5 9.5v6c0 .55-.45 1-1 1h-4m-5 0v3c0 .55.45 1 1 1h4" }
      })]
    );
  }
};